import { render, staticRenderFns } from "./MyBingohalls.vue?vue&type=template&id=2f53643e&scoped=true"
import script from "./MyBingohalls.vue?vue&type=script&lang=js"
export * from "./MyBingohalls.vue?vue&type=script&lang=js"
import style0 from "./MyBingohalls.vue?vue&type=style&index=0&id=2f53643e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f53643e",
  null
  
)

export default component.exports